module.exports = __webpack_public_path__ + "img/finance_9.e5c0c733.png";